import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {AzPageHeader} from '../../components/AzPageHeader'
import { AboutListWrapper } from './AboutComponent'
import { useIntl } from 'react-intl'

const AboutPage = () => {
  const intl = useIntl()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='about'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'ABOUT_PAGE.TITLE' })} />
              <AboutListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/About-management/About' />} />
    </Routes>
  )
}

export default AboutPage
